export default __webpack_public_path__ + "static/gato-estudio-balthazaurus-scroll-401d6b5d6453574e500bfad61697e5f5.gif";